const DEFAULT_LANG = 'pl';

class i8n {
	static current_lang = DEFAULT_LANG;
	static lib = {};

	static internationalize(phrase) {
		if(i8n.lib[phrase]){
			return i8n.lib[phrase][i8n.current_lang] || i8n.lib[phrase][DEFAULT_LANG];
		}
	}

	static provide(phrases) {
		if(!phrases[DEFAULT_LANG])
			throw Error('i8n error - phrase '+phrases+' must contain default language '+DEFAULT_LANG);
		i8n.lib[phrases[DEFAULT_LANG]] = phrases;
	}

	static setLang(code) {
		i8n.current_lang = code;
	}

	static inlineDef(phrases){
		i8n.provide(phrases);
		return i8n.internationalize(phrases[DEFAULT_LANG]) || '?no translation?';
	}

	static getUserLang(){
		return (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase();
	}
}

export {i8n};
export default i8n.inlineDef;


// WEBPACK FOOTER //
// ./src/i8n/index.js